<template>
  <div class="market-couponList-codeStore-index">
    <Search :renderData="renderData" :formData="form" :labelWidth="100" @onSearch="onSearch" >
      <el-button slot="btn" @click="onExport" :loading="exportLoading">导出</el-button>
    </Search>
    <div class="fun-btn-box">
      <auth-button auth="market:coupon:gift:code:template:get">
        <el-button class="down-btn mr10" @click="onDownloadTemplate" :loading="downloadLoading" >核销模板下载</el-button>
      </auth-button>
      <auth-button auth="market:coupon:gift:code:template:get">
        <el-button class="down-btn mr10" @click="onImportHexiao" :loading="importLoading" >核销数据导入</el-button>
      </auth-button>
    </div>
    <Table
      :tableThData="tableThData"
      :tableTrData="tableTrData"
      :loading="loading"
      :limit="limit"
      :total="total"
      :offset="offset"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
    > 
      <template #templateId="{ row }">{{ row.templateId ? row.templateId:'---' }}</template>
      <template #code="{ row }">{{ row.code }}</template>
      <template #cardNo="{ row }">{{ row.cardNo ? row.cardNo : '---' }}</template>
      <template #created="{ row }">{{ row.created ? $moment(row.created).format('YYYY/MM/DD HH:mm:ss') : '---' }}</template>
      <template #status="{ row }">{{ row.status }}</template>
      <template #updated="{ row }">{{ row.updated ? $moment(row.updated).format('YYYY/MM/DD HH:mm:ss') : '---' }}</template>
      <template #phone="{ row, scope }">
        <div v-if="row.phone">
        <span :key="tableKey">{{ row.phone_show || row.phone }}</span>
          <auth-button auth="user:phone:read">
            <el-button v-if="row.phone" class="look-phone-btn" type="text" @click="onLookPhone(row, scope.$index)">
              {{ row.phone_show ? '隐藏' : '查看' }}
            </el-button>
          </auth-button>
        </div>
        <span v-else>---</span>
      </template>
    </Table>
    <input v-if="showImport" ref="code-import-input" @change="importInputChange" class="code-import-input" type="file" accept=".xls, .xlsx">
  </div>
</template>

<script>
import AuthButton from '@/components/AuthButton'
import tableList from '@/mixins/tableList'
import { api_getCouponCodeDownload, api_postCouponCodeImportCouponUsed,api_getCouponCodeList,api_postCouponCodeExport} from '@/api/market'
import { api_getUserPhone } from "@/api/common";
import aes from "@/common/aes.js";
import { downFile } from "@/utils";
import Search from "@/components/Search/index";
import Table from "@/components/Table/index";
export default {
  name: "marketCouponListCodeStoreIndex",
  mixins: [ tableList ],
  components: {
    AuthButton,
    Search,
    Table,
  },
  data() {
    return {
      renderData: [
        {
          label: "导入时间",
          placeholder: ['开始时间', '结束时间'],
          type: "date-range",
          key: "time",
          valueFormat: 'timestamp',
        },
        {
          label: "券码",
          placeholder: "请输入券码",
          type: "input",
          key: "code",
        },
        {
          label: "券码状态",
          placeholder: "请选择券码状态",
          type: "select",
          key: "status",
          option: [
            { label: '未发放', value: 'New' },
            { label: '已发放', value: 'Issued' },
            // { label: '已核销', value: 'Used' },
          ],
        },
        {
          label: "会员手机号",
          placeholder: "请输入会员手机号",
          type: "input",
          key: "phone",
          maxLength: 11,
          isNumber: true
        },
      ],
      form: {},
      tableThData: [
        { prop: "templateId", label: "券模版Id", minWidth: "80", },
        { prop: "cardNo", label: "卡号", minWidth: "180", },
        { prop: "code", label: "券码", minWidth: "180", },
        { prop: "created", label: "导入时间", minWidth: "160", },
        { prop: "status", label: "券码状态", minWidth: "120", },
        { prop: "updated", label: "更新时间", minWidth: "160", },
        { prop: "phone", label: "会员手机号", minWidth: "160", },
      ],
      tableKey: false,
      downloadLoading: false,
      importLoading: false,
      exportLoading: false,
      showImport: false,
      issueTypeMap: {
        'Auto': '闰土自制',
        'Stock': '库存发放',
      },
    };
  },
  created () {
  },
  methods: {
    // 获取表格列表数据
    async getList () {
      this.loading = true
      const params = {
        ...this.form,
        templateId:this.$route.query.templateId,
        offset: this.offset,
        limit: this.limit,
      }
      params.usedTimeFrom = this.form.time ? this.form.time[0] : undefined
      params.usedTimeTo = this.form.time ? this.form.time[1] : undefined
      delete params.time
      this.$router.push({query: params})
      const data = await api_getCouponCodeList(params)
      console.log('data: ', data);
      this.tableTrData = data.list || []
      this.total = data.count
      this.loading = false
      this.showImport = true
    },

    // 点击编辑
    async onEdit(row, copy='') {
      this.$router.push({
        path: `/market/giftCouponList/add?id=${row.id}&copy=${copy}`
      });
    },

    // 点击查看手机号
    async onLookPhone(row, index) {
      if (row.phone_show) {
        delete this.tableTrData[index].phone_show;
      } else {
        const { phone } = await api_getUserPhone({ id: row.userId });
        this.tableTrData[index].phone_show = aes.decrypt(phone);
      }
      this.tableKey = !this.tableKey;
    },

    // 下载券码导入模板
    async onDownloadTemplate() {
      this.downloadLoading = true
      try {
        let res = await api_getCouponCodeDownload()
        downFile(res)
        this.downloadLoading = false
      } catch (err) {
        console.log('line:151 err: ', err);
        this.downloadLoading = false
      }
    },

    // 核销数据导入
    onImportHexiao() {
      this.$confirm("建议批量导入数据最多导500条", {
            showCancelButton: false,
            confirmButtonText: "确定",
            type: "warning",
          })
          .then(() => {
            this.$refs['code-import-input'].click()
          })
    },
    // 上传input改变事件
    async importInputChange(e) {
      try {
        const files = e.target.files
        let res = await api_postCouponCodeImportCouponUsed({
          file: files[0]
        })
        if (res) {
          try {
          let blob = new Blob([res]);//转换blob数据类型
          let reader = new FileReader();
          reader.readAsText(blob, "utf-8");
          let enc = new TextDecoder('utf-8')
          res = JSON.parse(enc.decode(new Uint8Array(res))) 
          console.log(res)
          this.$baseMessage('导入成功', 'success')
          } catch (error) {
            this.$baseMessage('导入失败，失败数据正在自动下载，请注意查看', 'error')
            this.downFile(res,'核销导入失败数据')
            console.log(error)
          }
      } 
        this.showImport = false
        this.getList()
      } catch (err) {
        console.log('err: ', err);
        this.showImport = false
        this.getList()
      }
      this.showImport = false
    },
    downFile(file, fileName) {
        const blob = new Blob([file], {
          type: 'application/ynd.ms-excel;charset=UTF-8'
        })
        const downloadElement = document.createElement('a')
        const href = window.URL.createObjectURL(blob)
        downloadElement.href = href
        downloadElement.download = `${fileName}.xlsx` // 定义文件名称
        document.body.appendChild(downloadElement)
        downloadElement.click()
        document.body.removeChild(downloadElement)
        window.URL.revokeObjectURL(href) // 释放掉blob对象
    },
    // 导出
    async onExport() {
      this.exportLoading = true
      const params = {
        templateId:this.$route.query.templateId,
        ...this.form,
      }
      this.form.time && this.form.time[0] && (params.usedTimeFrom = this.form.time[0])
      this.form.time && this.form.time[1] && (params.usedTimeTo = this.form.time[1])
      delete params.time
      delete params.offset
      delete params.limit
      try {
        const res = await api_postCouponCodeExport(params)
        res && downFile(res)
        this.exportLoading = false
      } catch (error) {
        this.exportLoading = false
      }
    },
  },
  watch: {
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.market-couponList-codeStore-index {
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;

  .code-import-input {
    height: 0px;
    visibility: hidden;
  }
  /deep/ .code_dialog {
    .el-dialog {
      width: 600px !important;
    }
    .content{
      height: 100px;
    }
  }
  .el-button {
    min-width: 80px !important;
  }

  .fun-btn-box {
    margin-top: 20px;
  }

  .del {
    color: #F74A4A;
  }
}
</style>
